import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { DynamicFormComponent } from '../../../../CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { FieldConfig } from '../../../../CommonComponents/dynamic-form/interface/field.interface';
import { NotificationService } from '../../../../Service/notification.service';
import { IPeerReviewDedOutputModel } from '../../../../ViewModel/PeerReviewModel';

@Component({
  selector: 'app-add-impact-dialog',
  templateUrl: './add-impact-dialog.component.html',
  styleUrls: ['./add-impact-dialog.component.css']
})
export class AddImpactDialogComponent implements OnInit, AfterViewInit {
  valueArray = [];
  impactArray = [];
  impactShortDesc: string[] = [];

  impactConfig: FieldConfig[] = [];
  @ViewChild('docSetForm') impactSetFormComponent!: DynamicFormComponent;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public _dialogRef: MatDialogRef<AddImpactDialogComponent>,
    public notificationService: NotificationService) { }

  ngOnInit(): void {
    this.resetImpactValues(); // Reset
  }

  ngAfterViewInit() {
    this.loadImpactControls(); // Load Impact controls
  }

  // Close dialog
  closeDialog() {
    this._dialogRef.close();
  }

  loadImpactControls() {
    this.data.impactTypes.forEach((impactType: IPeerReviewDedOutputModel) => {
      let tempFieldConfig: FieldConfig;
      tempFieldConfig = {
        type: 'input',
        name: impactType.deD_Short_Description,
        label: impactType.deD_Description
      }

      // Set impact value details, when already posted
      if (this.data && this.data.valueArray && this.data.valueArray.length > 0) {
        let tempImpactValue = this.data.valueArray.filter(x => x.DedId == impactType.deD_Id).map(y => y.val);

        if (tempImpactValue.length > 0) {
          tempFieldConfig.value = new BehaviorSubject(tempImpactValue[0]);
        }
      }

      this.impactConfig.push(tempFieldConfig);
      this.impactShortDesc.push(impactType.deD_Short_Description); // Store Impact short description
    });

    // Create Impact controls
    this.impactSetFormComponent.fields = [];
    this.impactSetFormComponent.fields = this.impactConfig;
    this.impactSetFormComponent.createControl();
  }

  // Reset impact values
  resetImpactValues() {
    this.valueArray = [];
    this.impactArray = [];
  }

  // Validate details
  validate(impactData) {
    let isValid = false;

    this.impactShortDesc.forEach(impactKey => {
      if (impactData[impactKey]) {
        isValid = true
      }
    });

    return isValid;
  }

  // Set impact values for payload
  setRequestData(impactData) {
    this.impactShortDesc.forEach(impactKey => {
      if (impactData[impactKey]) {
        let tempImpactType = this.data.impactTypes.find(data => data.deD_Short_Description == impactKey);

        if (tempImpactType) {
          this.impactArray.push(tempImpactType);
          this.valueArray.push({ 'DedId': tempImpactType.deD_Id, 'val': impactData[impactKey] });
        }
      }
    });
  }

  // Post impact details
  postImpactDetails() {
    if (!this.validate(this.impactSetFormComponent.value.value)) {
      this.notificationService.showToast("Please enter at least one Impact.", "Warning");
      return;
    }

    // Set request details
    this.setRequestData(this.impactSetFormComponent.value.value);

    // Return the selected Impact details
    let obj: any = {};
    obj["impactArray"] = this.impactArray;
    obj["valueArray"] = this.valueArray;
    this._dialogRef.close(obj);
  }
}
